/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Brands_Playdata_Tagline1Inputs */

const ja_home_brands_playdata_tagline1 = /** @type {(inputs: Home_Brands_Playdata_Tagline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ゲーム・eスポーツ大会のライブ配信分析サービス`)
};

const en_home_brands_playdata_tagline1 = /** @type {(inputs: Home_Brands_Playdata_Tagline1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`UNDERSTAND GAME STREAMS WITH ANALYTICS`)
};

/**
* | output |
* | --- |
* | "UNDERSTAND GAME STREAMS WITH ANALYTICS" |
*
* @param {Home_Brands_Playdata_Tagline1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const home_brands_playdata_tagline1 = /** @type {((inputs?: Home_Brands_Playdata_Tagline1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Brands_Playdata_Tagline1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_home_brands_playdata_tagline1(inputs)
	return en_home_brands_playdata_tagline1(inputs)
});
export { home_brands_playdata_tagline1 as "home_brands_playdata_tagLine" }